import { NgModule } from '@angular/core';
import { JoinPipe } from 'src/app/pipes/join.pipe';
import { SplitPipe } from 'src/app/pipes/split.pipe';
import { FilterPipe } from 'src/app/pipes/filter.pipe';
import { FindPipe } from './find.pipe';
import { IsInPipe } from './is-in.pipe';
import { ResolveDeploymentSubscription } from 'src/app/pipes/resolve-deployment-subscription';
import { DurationPipe } from 'src/app/pipes/duration.pipe';
import { IsNotInPipe } from 'src/app/pipes/is-not-in.pipe';
import { HumanizePipe } from './humanize.pipe';
import { TrimPipe } from './trim.pipe';

@NgModule({
  declarations: [
    JoinPipe,
    SplitPipe,
    FilterPipe,
    FindPipe,
    IsInPipe,
    ResolveDeploymentSubscription,
    DurationPipe,
    IsNotInPipe,
    HumanizePipe,
    TrimPipe
  ],
  exports: [
    JoinPipe,
    SplitPipe,
    FilterPipe,
    FindPipe,
    IsInPipe,
    ResolveDeploymentSubscription,
    DurationPipe,
    IsNotInPipe,
    HumanizePipe,
    TrimPipe
  ],
  providers: [
  ]
})
export class PipesModule { }
